import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { DacConfig } from 'app/shared/services/dac-config.service';
import { Role } from 'app/shared/models/role';
import { AlertService } from 'app/shared/services/alert.service';
var SsoComponent = /** @class */ (function () {
    function SsoComponent(route, dacConfig, router, authService, alertService) {
        this.route = route;
        this.dacConfig = dacConfig;
        this.router = router;
        this.authService = authService;
        this.alertService = alertService;
        this._ssoFailed = false;
        this._debugAlerts = false;
        this.log("SsoComponent");
        this._storageAccessRequired = false;
    }
    SsoComponent.prototype.log = function (msg) {
        if (this._debugAlerts) {
            this.alertService.error(msg);
        }
        else {
            console.log(msg);
        }
    };
    Object.defineProperty(SsoComponent.prototype, "title", {
        get: function () {
            return this.dacConfig.applicationTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsoComponent.prototype, "isSeamless", {
        get: function () {
            return this.dacConfig.seamlessMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsoComponent.prototype, "ssoFailed", {
        get: function () {
            return this._ssoFailed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsoComponent.prototype, "storageAccessRequired", {
        get: function () {
            return this._storageAccessRequired;
        },
        enumerable: true,
        configurable: true
    });
    SsoComponent.prototype.ngInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.log("Query params are subscribed inside ngInit()");
        });
        this.alertService.error("show something here");
    };
    SsoComponent.prototype.ngAfterViewInit = function () {
        this.loadSSO(); // for now we just load the sso and don't deal with the storage access stuff.
    };
    SsoComponent.prototype.grantStorageAccess = function () {
        var _this = this;
        // @ts-ignore
        var storageAccessGranted = document.requestStorageAccess();
        storageAccessGranted.then(function (isAccessGranted) {
            if (isAccessGranted === true || isAccessGranted === undefined) {
                _this._storageAccessRequired = false;
                _this.loadSSO();
            }
            else {
                _this.alertService.error("Storage access is required to use this service");
            }
        })
            .catch(function (reason) {
            console.error(reason);
            _this.alertService.error(reason);
            _this.alertService.error("Storage access is required to use this service");
        });
    };
    SsoComponent.prototype.requestStorageAccess = function () {
        var _this = this;
        var storageAccessGranted = Promise.resolve(true);
        if (!window.document['requestStorageAccess']) {
            console.error("requestStorageAccess() called when window.Document.requestStorageAccess does not exist");
        }
        else {
            storageAccessGranted = window.document['requestStorageAccess']();
        }
        storageAccessGranted.then(function (isAccessGranted) {
            if (isAccessGranted) {
                _this.loadSSO();
            }
            else {
                _this.loadStorageAccessNeeded();
            }
        });
    };
    SsoComponent.prototype.loadStorageAccessNeeded = function () {
        this._storageAccessRequired = true;
    };
    SsoComponent.prototype.loadSSO = function () {
        var _this = this;
        this.log("SsoComponent ngAfterViewInit ");
        var time = new Date();
        this.log("Inside the ngAfterViewInt just before subscribe of query params");
        this.route.queryParams.subscribe(function (params) {
            _this.authService.authenticateSSO(params.RelayState)
                .then(function (userResp) {
                _this.log("User response is: " + JSON.stringify(userResp));
                var route = userResp.redirectUrl;
                if (userResp.issuer) {
                    _this.dacConfig.setupSSOIssuerForSession(userResp.issuer);
                }
                if (!route) {
                    route = userResp.role == Role.Client ? "/assessments/dashboard/" : "/admin/dashboard/";
                }
                // so we don't just quickly flash through give a second to 
                if (new Date().getTime() < (time.getTime() + 1000)) {
                    setTimeout(function () {
                        _this.router.navigate([route]);
                    }, 1000);
                }
                else {
                    _this.router.navigate([route]);
                }
            })
                .catch(function (error) {
                _this.log(error);
                // TODO: stephen if there is no error we should display something here...
                if (error.redirectURL) {
                    window.location.href = error.redirectURL;
                }
                else {
                    _this._ssoFailed = true;
                }
            });
        });
    };
    SsoComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(SsoComponent.prototype, "supportPhone", {
        // TODO: stephen abstract this all into a footer component.
        get: function () {
            return this.dacConfig.supportPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsoComponent.prototype, "supportEmail", {
        get: function () {
            return this.dacConfig.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsoComponent.prototype, "mailLink", {
        get: function () {
            return "mailto:" + this.supportEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsoComponent.prototype, "phoneLink", {
        get: function () {
            return "tel:" + this.supportPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsoComponent.prototype, "copyrightTitle", {
        get: function () {
            return this.dacConfig.copyrightTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SsoComponent.prototype, "copyrightURL", {
        get: function () {
            return this.dacConfig.copyrightURL;
        },
        enumerable: true,
        configurable: true
    });
    return SsoComponent;
}());
export { SsoComponent };



// WEBPACK FOOTER //
// ./src/app/login/sso/sso.component.ts.pre-build-optimizer.js